import initHeader from '../_modules/header/index'
import { revealLinksOnAction } from '../_modules/helpers'
import { initSendMessage } from './form/index'
import { handleRef, REFS_US } from '@studybay/common-client-library/ref-handle';
import { FirstTouchTracking } from '@studybay/common-client-library/first-touch-tracking';

initHeader()
initSendMessage()
revealLinksOnAction(() => {
    handleRef(REFS_US.SEO_US_INFO)
    FirstTouchTracking()
})
